
import React from "react";
import PropTypes from "prop-types";
import {
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import compose from "recompose/compose";


const MainLoadingIndicator = ({
  isLoading
}) => 
  isLoading ? (
    <div className="main-loading-indicator">
      <Spinner color="secondary" />
    </div>
  ) : null;

MainLoadingIndicator.propTypes = {
  isLoading: PropTypes.bool,
};

export default compose(
  connect(
    ( state, props ) => ({
      isLoading: state.main.loadingVersion > 0,
    })
  )
)(MainLoadingIndicator);
